import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { MUTATION_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';

export const useDeletePatient = (): UseMutationResult<
  void,
  Error,
  { userId: string; redirect?: boolean }
> => {
  const { t } = useTranslation(LOCIZE_NS.PROFILE);

  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_PATIENT],
    mutationFn: async ({ userId, redirect }: { userId: string; redirect?: boolean }) => {
      await PatientService.deletePatient(userId, redirect);
    },
    onSuccess: () => {
      toast.success(t('DeleteAccount.success'));
    },
    onError: () => {
      toast.error(t('DeleteAccount.error'));
    },
  });
};
